import React, { forwardRef } from 'react';
import cn from '../../utils/cn';

const Input = forwardRef(({ label, error, id, className = '', ...props }, ref) => (
  <div className="flex flex-col gap-1">
    {label && (
      <label htmlFor={id} className="text-sm font-medium text-gray-700">
        {label}
      </label>
    )}
    <input
      id={id}
      ref={ref}
      className={cn(
        'w-full px-3.5 py-2.5 rounded-lg border text-sm text-gray-900 bg-white',
        'placeholder:text-gray-400 transition-all duration-150',
        'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent',
        error
          ? 'border-red-400 focus:ring-red-400'
          : 'border-gray-300 hover:border-gray-400',
        className
      )}
      aria-invalid={!!error}
      aria-describedby={error ? `${id}-error` : undefined}
      {...props}
    />
    {error && (
      <p id={`${id}-error`} className="text-xs text-red-500 flex items-center gap-1" role="alert">
        <svg className="w-3 h-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
        {error}
      </p>
    )}
  </div>
));

Input.displayName = 'Input';
export default Input;
